export const LinkType = {
  ShoppableLink: 'ShoppableLink',
  DovetaleAffiliateLink: 'DovetaleAffiliateLink',
  ExternalLink: 'ExternalLink',
  SpotifyAlbumLink: 'SpotifyAlbumLink',
  SpotifyArtistLink: 'SpotifyArtistLink',
  SpotifyPlaylistLink: 'SpotifyPlaylistLink',
  SpotifyPodcastLink: 'SpotifyPodcastLink',
  SpotifyShowLink: 'SpotifyShowLink',
  SpotifySongLink: 'SpotifySongLink',
  YouTubePlaylistLink: 'YouTubePlaylistLink',
  YouTubeVideoLink: 'YouTubeVideoLink',
  AmazonAffiliateLink: 'AmazonAffiliateLink',
} as const;

export type LinkType = (typeof LinkType)[keyof typeof LinkType];
